import React from 'react';
import { Form, Input, Button, Spin, message, Layout} from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { authLogin } from '../actions/auth';
import {setCurrentRoute} from '../actions';
import history from '../history';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 8 }
};
const tailLayout = {
  wrapperCol: { offset: 8, span: 8 },
};


class Login extends React.Component {

    componentDidMount = () => {
        this.props.setCurrentRoute(history.location.pathname)
    }

    onFinish = values => {
        this.props.onAuth(values.username, values.password)
        // console.log('Success:', values);
      };
    
    onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
      };

    render() {
        let errorMessage = null;
        if (this.props.error) {
            errorMessage = (
                message.error(`${this.props.error.message}`, 5)
            )  
        }
        return  (
            <Layout style={{ height: '100vh' }}>

            <div style={{textAlign: "center"}}>
                {errorMessage}
            {
                this.props.loading ?

                <Spin indicator={antIcon} />
                
                :
            
                <Form
                    {...layout}
                    name="basic"
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                    style = {{marginTop:"10%"}}
                    >

                    <Form.Item
                        label="Username"
                        name="username"
                        rules={[
                        {
                            required: true,
                            message: 'Please input your username!',
                        },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[
                        {
                            required: true,
                            message: 'Please input your password!',
                        },
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Button type="primary" htmlType="submit" style={{borderRadius:'100px'}}>
                            Login
                        </Button>
                    </Form.Item>
                </Form>
            }

            </div>
            </Layout>
          );
    };
};

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.auth.token != null,
        loading: state.auth.loading,
        error: state.auth.error
    }
} 

const mapDispatchToProps = (dispatch) => {
    return {
        onAuth: (username, password) => {dispatch(authLogin(username, password))},
        setCurrentRoute: (route) => {dispatch(setCurrentRoute(route))}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);